import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Cancel, DropDown, Field, Submit } from './textField';
import { getStatesDropDown,getLocationDropDown, getSiteDropDown } from '../api/serverApi';
import { useState,useEffect } from 'react';
import {
  DialogContent,
} from '@mui/material';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  maxHeight: 600,
  minHeight: 300,
  bgcolor: 'background.paper',
  boxShadow: 24,
  overflow: 'auto',
};


const SiteModal = ({open,handleClose,handleSubmit,formContent,title}) => {
  if (!open) return null;
    
    
return (
<Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" className='px-6 pt-4'>
            {title}
          </Typography>
          <Typography id="modal-modal-description">
          <DialogContent>
        {formContent}
      </DialogContent>
            
            <div className='p-4 flex justify-end '>
                <Cancel Name="Cancel" onClose={handleClose} />
                <Submit Name="Submit" onSubmit={handleSubmit} />
            </div>
          </Typography>
        </Box>
      </Modal>
)
}


export default SiteModal